import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SmsPolicy = () => {
  return (
    <>
      <Helmet>
        <title>SMS Policy - Ursus Victor LLC</title>
        <meta name="description" content="SMS and Text Messaging Policy for Ursus Victor LLC. Learn about our text message communications and how to opt out." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            SMS & Text Messaging Policy
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Last Updated: December 4, 2024
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              1. SMS Program Overview
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Ursus Victor LLC offers SMS text messaging services to provide you with updates, reminders, 
              and information about your loan application support request and documentation preparation process. This policy 
              explains how our SMS program works and your rights regarding text message communications.
            </p>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              <strong>You must be at least 18 years of age</strong> to opt in to receive SMS messages from us.
            </p>
            <div style={{
              background: '#dbeafe',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6'
            }}>
              <p style={{fontSize: '1rem', color: '#1e40af', fontWeight: '600', marginBottom: '0.75rem'}}>
                Our A2P Campaign Purpose:
              </p>
              <p style={{fontSize: '0.95rem', color: '#1e40af', lineHeight: '1.7'}}>
                We provide loan application support and documentation services to help individuals and businesses prepare complete, 
                accurate loan applications. Customers opt in via our website contact form to receive application status updates, 
                document requirement notifications, and support request confirmations. We are NOT a lender and do NOT make lending decisions.
              </p>
            </div>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              2. SMS Phone Number and Service Provider
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Text messages from Ursus Victor LLC are sent through Twilio, our SMS service provider. Messages will be 
              delivered from a Twilio phone number or short code. The specific sender ID may vary.
            </p>
            <div style={{
              background: '#f9fafb',
              padding: '1.5rem',
              borderRadius: '8px',
              border: '1px solid #e5e7eb'
            }}>
              <p style={{fontSize: '1rem', color: '#374151', fontWeight: '600', marginBottom: '0.75rem'}}>
                SMS Service Details:
              </p>
              <ul style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', paddingLeft: '1.5rem'}}>
                <li>Messages sent via Twilio SMS platform</li>
                <li>Sender ID: Twilio phone number or short code</li>
                <li>Message delivery: Real-time via major US carriers</li>
                <li>Business hours: Monday-Friday, 9 AM - 6 PM EST</li>
                <li>No weekend or holiday messages</li>
              </ul>
            </div>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              3. Consent to Receive Text Messages
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              By providing your mobile phone number and opting in to receive SMS messages from Ursus Victor LLC, 
              you expressly consent to receive:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem', marginBottom: '1.5rem'}}>
              <li>Loan application support updates</li>
              <li>Document requirement notifications</li>
              <li>Application status updates</li>
              <li>Updates about your support request</li>
              <li>Document checklist reminders</li>
              <li>Application preparation guidance</li>
            </ul>
            <div style={{
              background: '#f9fafb',
              padding: '1.5rem',
              borderRadius: '8px',
              border: '1px solid #e5e7eb'
            }}>
              <p style={{fontSize: '1rem', color: '#374151', fontWeight: '600', marginBottom: '1rem'}}>
                Sample Messages You May Receive:
              </p>
              <ul style={{fontSize: '0.9rem', color: '#6b7280', lineHeight: '1.7', paddingLeft: '1.5rem', listStyle: 'none'}}>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "Thank you for contacting Ursus Victor LLC. Your application support request is received. Reply STOP to opt out."
                </li>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "Your document checklist is ready for review. Reply STOP to unsubscribe."
                </li>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "We need additional documents to continue your application support. Reply STOP to opt out."
                </li>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "Your application review session is scheduled. Reply STOP to cancel updates."
                </li>
                <li>
                  💬 "Your application package is ready for submission guidance. Reply STOP to unsubscribe."
                </li>
              </ul>
            </div>
          </div>

          <div style={{
            background: '#fef3c7',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            marginBottom: '3rem'
          }}>
            <h3 style={{fontSize: '1.3rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem'}}>
              📱 TCPA Compliance Notice
            </h3>
            <p style={{fontSize: '1rem', color: '#78350f', lineHeight: '1.7'}}>
              By opting in to receive SMS messages, you provide your express written consent under the Telephone 
              Consumer Protection Act (TCPA) to receive automated marketing text messages from Ursus Victor LLC 
              at the mobile number provided. Consent is not a condition of purchase. Message and data rates may apply.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              4. Message Frequency and Timing
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              Message frequency varies depending on your application support status and preferences. We offer two types of SMS communications:
            </p>
            <div style={{
              background: '#f9fafb',
              padding: '1.5rem',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              marginBottom: '1.5rem'
            }}>
              <p style={{fontSize: '1rem', color: '#374151', fontWeight: '600', marginBottom: '1rem'}}>
                <strong>Transactional Messages (Required):</strong>
              </p>
              <p style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', marginBottom: '1rem'}}>
                Service-related messages about your application support request:
              </p>
              <ul style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', paddingLeft: '1.5rem'}}>
                <li>Application confirmation messages</li>
                <li>Document requirement notifications</li>
                <li>Application status updates</li>
                <li>Support request confirmations</li>
                <li>Appointment reminders</li>
              </ul>
              <p style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', marginTop: '1rem'}}>
                <strong>Frequency:</strong> 2-5 messages per month depending on your application activity
              </p>
            </div>
            <div style={{
              background: '#f9fafb',
              padding: '1.5rem',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              marginBottom: '1.5rem'
            }}>
              <p style={{fontSize: '1rem', color: '#374151', fontWeight: '600', marginBottom: '1rem'}}>
                <strong>Marketing Messages (Optional):</strong>
              </p>
              <p style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', marginBottom: '1rem'}}>
                Promotional and educational content (only if you opt in):
              </p>
              <ul style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', paddingLeft: '1.5rem'}}>
                <li>Financial tips and loan preparation advice</li>
                <li>New service announcements</li>
                <li>Special offers and promotions</li>
                <li>Partner offers from financial institutions</li>
                <li>Educational content about funding</li>
              </ul>
              <p style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', marginTop: '1rem'}}>
                <strong>Frequency:</strong> 2-4 messages per month (max 10 marketing messages per month combined)
              </p>
            </div>
            <div style={{
              background: '#dbeafe',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6'
            }}>
              <p style={{fontSize: '1rem', color: '#1e40af', fontWeight: '600', marginBottom: '0.75rem'}}>
                Message Timing:
              </p>
              <p style={{fontSize: '0.95rem', color: '#1e40af', lineHeight: '1.7'}}>
                All messages are sent during business hours: <strong>Monday-Friday, 9 AM - 6 PM EST</strong>. We do not send 
                messages on weekends or federal holidays. You will never receive excessive or spam messages from us.
              </p>
            </div>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              5. Message and Data Rates
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Standard message and data rates may apply based on your mobile carrier's plan. Ursus Victor LLC 
              does not charge for text messages, but your carrier may charge you for messages sent and received. 
              Please contact your mobile carrier for details about your messaging plan.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              6. How to Opt Out (STOP)
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              You can opt out of receiving SMS messages at any time by:
            </p>
            <div style={{
              background: '#dbeafe',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6',
              marginBottom: '1rem'
            }}>
              <p style={{fontSize: '1.1rem', color: '#1e40af', fontWeight: '600', marginBottom: '0.75rem'}}>
                Text "STOP" to our SMS number
              </p>
              <p style={{fontSize: '0.95rem', color: '#1e40af', lineHeight: '1.6'}}>
                Reply with the word STOP, END, CANCEL, UNSUBSCRIBE, or QUIT to any message you receive from us. 
                You will receive a confirmation message that you have been unsubscribed. After this, you will no 
                longer receive SMS messages from us unless you opt in again.
              </p>
            </div>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              You can also contact us directly at <a href="mailto:support@ursusconnects.com" style={{color: '#3b82f6'}}>support@ursusconnects.com</a> to opt out.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              7. Help and Support (HELP)
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              For help or more information about our SMS program:
            </p>
            <div style={{
              background: '#dbeafe',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6',
              marginBottom: '1rem'
            }}>
              <p style={{fontSize: '1.1rem', color: '#1e40af', fontWeight: '600', marginBottom: '0.75rem'}}>
                Text "HELP" to our SMS number
              </p>
              <p style={{fontSize: '0.95rem', color: '#1e40af', lineHeight: '1.6'}}>
                Reply with the word HELP to any message you receive from us, and you will receive information 
                about the program and how to contact us.
              </p>
            </div>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              You can also email us at <a href="mailto:support@ursusconnects.com" style={{color: '#3b82f6'}}>support@ursusconnects.com</a> for assistance.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              8. Supported Carriers
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Our SMS program is supported by all major U.S. mobile carriers, including:
            </p>
            <p style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', paddingLeft: '1rem'}}>
              AT&T, T-Mobile, Verizon, Sprint, Boost Mobile, Cricket Wireless, MetroPCS, U.S. Cellular, Virgin Mobile, 
              and many others. If you experience issues receiving messages, please contact your carrier or reach out to us.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              9. Privacy and Data Protection
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Your mobile phone number and SMS preferences are protected under our <Link to="/privacy" style={{color: '#3b82f6', textDecoration: 'underline'}}>Privacy Policy</Link>. 
              We will not sell, rent, or share your mobile number with third parties for their marketing purposes 
              without your explicit consent. We may share your information with service providers who help us deliver 
              SMS messages and with financial institutions as part of our application support services.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              10. Changes to Phone Number
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              If you change your mobile phone number, please notify us immediately to update your contact information 
              and ensure you continue to receive important messages. You can update your number by contacting us or 
              through your account settings if applicable.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              11. Liability and Disclaimer
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Ursus Victor LLC and mobile carriers are not liable for delayed or undelivered messages. 
              We are not responsible for any charges or fees imposed by your mobile carrier. Message delivery is 
              subject to your carrier's network availability and may be affected by factors beyond our control.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              12. Changes to SMS Policy
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We may update this SMS Policy from time to time. We will notify you of any material changes by sending 
              a text message or by posting the updated policy on our website. Your continued participation in our SMS 
              program after changes are made constitutes acceptance of the updated policy.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              13. Contact Information
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              For questions about our SMS program or this policy:
            </p>
            <div style={{
              background: '#dbeafe',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6'
            }}>
              <p style={{fontSize: '1rem', color: '#1e40af', marginBottom: '0.5rem'}}>
                <strong>Ursus Victor LLC</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#1e40af', marginBottom: '0.5rem'}}>
                SMS Inquiries: <a href="mailto:support@ursusconnects.com" style={{color: '#3b82f6'}}>support@ursusconnects.com</a>
              </p>
              <p style={{fontSize: '1rem', color: '#1e40af'}}>
                General Contact: <a href="mailto:info@ursusconnects.com" style={{color: '#3b82f6'}}>info@ursusconnects.com</a>
              </p>
            </div>
          </div>

          <div style={{
            background: '#dbeafe',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #3b82f6',
            textAlign: 'center'
          }}>
            <p style={{fontSize: '1.1rem', color: '#1e40af', lineHeight: '1.7', marginBottom: '1rem'}}>
              <strong>Quick Reference</strong>
            </p>
            <div style={{display: 'grid', gap: '0.75rem', fontSize: '1rem', color: '#1e40af'}}>
              <p>📱 <strong>To Opt Out:</strong> Text STOP</p>
              <p>❓ <strong>For Help:</strong> Text HELP</p>
              <p>📧 <strong>SMS Support:</strong> support@ursusconnects.com</p>
              <p>📧 <strong>General Support:</strong> info@ursusconnects.com</p>
            </div>
          </div>

          <div style={{marginTop: '3rem', textAlign: 'center', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
            <Link to="/privacy" style={{
              background: 'white',
              color: '#1e40af',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #1e40af'
            }}>
              Privacy Policy
            </Link>
            <Link to="/terms" style={{
              background: 'white',
              color: '#1e40af',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #1e40af'
            }}>
              Terms of Service
            </Link>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem'
            }}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default SmsPolicy;
